import PropertyLowRatesCalendarMobile from '../../../../components/containers/PropertyLowRatesCalendarContainerMobile';
import preloadCustomProps from '../../../utils/preloads/preloadPropertyLowRatesCalendarProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'property-low-rates-calendar--mobile',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: PropertyLowRatesCalendarMobile
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
